import BaseResource from './base-resource';
import JsonApiReference from './jsonapi-reference';
import JsonApiResource from './jsonapi-resource';
import ReferenceResolver from './reference-resolver';

export default class ReportResource extends BaseResource {
  name: string;
  donwloadLink: string;

  constructor(init?: Partial<ReportResource>) {
    super(init, 'reports');
    this.initialize(init);
  }
}



// WEBPACK FOOTER //
// ./common/models/report-resource.ts